import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Home, BarChart3, Clock, Search } from "lucide-react";
import { track404 } from "../helpers/analytics";
import styles from "./NotFound.module.css";

const SUGGESTED_LINKS = [
  { to: "/", label: "Page d'accueil", icon: Home, external: true as const },
  { to: "/keno-statistiques/", label: "Statistiques Keno", icon: BarChart3, external: true as const },
  { to: "/derniers-tirages-keno/", label: "Historique des tirages", icon: Clock, external: true as const },
  { to: "/keno-statistiques/#ecarts", label: "Baromètre des écarts", icon: Search, external: true as const },
];

export const NotFound: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    track404(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Page introuvable - KenoMetric</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className={styles.content}>
        <span className={styles.code}>404</span>
        <h1 className={styles.title}>Page introuvable</h1>
        <p className={styles.description}>
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>

        <nav className={styles.links}>
          <p className={styles.linksLabel}>Pages populaires :</p>
          <ul className={styles.linksList}>
            {SUGGESTED_LINKS.map(({ to, label, icon: Icon, external }) => (
              <li key={to}>
                {external ? (
                  <a href={to} className={styles.link}>
                    <Icon size={18} />
                    {label}
                  </a>
                ) : (
                  <Link to={to} className={styles.link}>
                    <Icon size={18} />
                    {label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};
